import { connect } from "react-redux";
import { selectBalancingSkipProductionFactor } from "../../balancingSelectors/selectBalancingConstants";
import { BuildingStateType } from "../../utils/network/generated/protoTypes";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionBuildingsSkipConstruction } from "../player-base/buildings/actionBuildings";
import { ContextMenuRunningProcess } from "./ContextMenuRunningProcess";
var mapState = function (state) { return ({
    getProcessRemainingTime: function (building) {
        return building.proto.remainingTime;
    },
    getProcessTotalTime: function (building) {
        var proto = building.proto, balancing = building.balancing;
        var stage = proto.state === BuildingStateType.CONSTRUCTING
            ? proto.stage - 1
            : proto.stage;
        return balancing.stage[stage].constructionTime;
    },
    icon: state.playerBase.buildings.building.proto.state === BuildingStateType.CONSTRUCTING
        ? IdIcon.ProductionIcn
        : IdIcon.UpgradeIcn,
    skipProcessFactor: selectBalancingSkipProductionFactor(),
}); };
var mapDispatch = function (dispatch) { return ({
    onSkip: function (building) { return dispatch(actionBuildingsSkipConstruction(building)); },
}); };
export var ContextMenuRunningConstructionDOM = connect(mapState, mapDispatch)(ContextMenuRunningProcess);



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuRunningConstructionDOM.tsx
// module id = 2248
// module chunks = 3